type Preschool = {
  PreschoolCDSCode: string;
  PreschoolName: string;
};

type ChildForHeading = {
  ChildFirstName?: string | null;
  ChildLastName?: string | null;
  LocalChildId?: string | null;
  PreschoolCode?: string | null;
  CSPPID?: string | null;
};

export function childHeadingModel({
  child,
  leaid,
  preschools,
}: {
  child: ChildForHeading;
  leaid: string;
  preschools: Preschool[];
}) {
  const childName =
    `${child.ChildFirstName ?? ""} ${child.ChildLastName ?? ""}`.trim();

  const first = child.ChildFirstName?.[0] ?? "";
  const last = child.ChildLastName?.[0] ?? "";
  const initials = `${first}${last}`.trim() || child.LocalChildId?.[0] || "?";

  const school =
    preschools.find((x) => x.PreschoolCDSCode === child.PreschoolCode)
      ?.PreschoolName ?? "Unknown preschool";

  return {
    childName,
    initials,
    leaid,
    school,
    csppid: child.CSPPID ?? "",
    localId: child.LocalChildId ?? "",
  };
}
